import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

/** Reusable modal shell for forms. */
export const Modal = ({ open, onClose, title, subtitle, children, testId }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        className="fixed inset-0 z-[70] bg-[#0a1628]/80 backdrop-blur-sm flex items-center justify-center p-4"
        data-testid={testId}
      >
        <motion.div
          initial={{ scale: 0.9, y: 20 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.9, y: 20 }}
          transition={{ type: 'spring', stiffness: 300, damping: 25 }}
          onClick={(e) => e.stopPropagation()}
          className="relative w-full max-w-md bg-gradient-to-br from-[#0f1f3a] to-[#0a1628] rounded-2xl border border-[#7dd3fc]/30 shadow-2xl overflow-hidden"
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white/50 hover:text-white transition-colors z-10"
            aria-label="Fechar"
            data-testid={`${testId}-close`}
          >
            <X size={22} />
          </button>
          <div className="p-8">
            <h3 className="text-2xl font-bold text-white mb-2">{title}</h3>
            {subtitle && <p className="text-white/60 text-sm mb-6">{subtitle}</p>}
            {children}
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
